module.exports = __webpack_public_path__ + "img/HC1020-70.9133cb71.jpg";